import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PatientPortalComponent } from './patient-portal.component';
import { PatientPortalHomeComponent } from './patient-portal-home/patient-portal-home.component';
//import { PatientPortalCheckInComponent } from './patient-portal-check-in/patient-portal-check-in.component';
import { PatientPortalMyInfoComponent } from './patient-portal-my-info/patient-portal-my-info.component';
import { PatientPortalFormsComponent } from './patient-portal-forms/patient-portal-forms.component';
import { PatientPortalPaymentsComponent } from './patient-portal-payments/patient-portal-payments.component';
import { PatientPortalTreatmentsComponent } from './patient-portal-treatments/patient-portal-treatments.component';
import { PatientPortalPlansComponent } from './patient-portal-plans/patient-portal-plans.component';
import { PatientPortalAppointmentComponent } from './patient-portal-appointment/patient-portal-appointment.component';

const routes: Routes = [{
  path: '', component: PatientPortalComponent,
  children: [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'home', component: PatientPortalHomeComponent },
    { path: 'profile', component: PatientPortalMyInfoComponent },
    { path: 'payment', component: PatientPortalPaymentsComponent },
    { path: 'appointment/print', component: PatientPortalAppointmentComponent },
    { path: 'treatments', component: PatientPortalTreatmentsComponent },
    { path: 'form/:formId', component: PatientPortalFormsComponent },
    { path: 'paymentPlans', component: PatientPortalPlansComponent },
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PatientPortalRoutingModule { }
